<h1 mat-dialog-title style="text-align: center">Install Digital Circular</h1>
<div mat-dialog-content style="text-align: center; font-size: 18px;">
  Add this PWA to your home screen for a better experience.
</div>
<div mat-dialog-content style="text-align: center; font-size: 14px;">
    Tap <img style="width: 25px;" src="../assets/icons/android-dots.png" alt=""> then "Add to Home Screen"
</div>
<!-- <div mat-dialog-actions style="justify-content: space-around;">
  <button mat-button mat-dialog-close>Close</button>
</div> -->